import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LayoutDashboard, Ticket, Building2, Radio, Bell, Menu } from 'lucide-react';
import { instanciaTiene } from '../../utils/brand';

export default function MobileBottomNav({ ticketBadge, onOpenSidebar, onOpenNotifications, notificationCount }) {
  const { t } = useTranslation();
  const location = useLocation();

  // La lista estaba escrita a mano y sin filtrar: en la instancia de un cliente aparecía
  // "Monitor", un módulo que ahí no existe, y el botón llevaba a una pantalla rota (la ruta
  // no tiene guard y la API responde 404). Es la navegación PRINCIPAL en el teléfono.
  // Se filtra por la lista de la instancia — no por permisos de usuario — para no cambiarle
  // la barra a nadie en nuestra instancia, donde no hay lista y pasa todo.
  const items = [
    { to: '/', icon: LayoutDashboard, label: t('nav.dashboard'), end: true, modulo: 'dashboard' },
    { to: '/tickets', icon: Ticket, label: t('nav.tickets'), badge: ticketBadge, modulo: 'tickets' },
    { to: '/companies', icon: Building2, label: t('nav.clients'), modulo: 'companies' },
    { to: '/monitor', icon: Radio, label: t('monitor.title'), modulo: 'monitoring' },
    { action: 'notifications', icon: Bell, label: t('notifications.title'), badge: notificationCount },
    { action: 'sidebar', icon: Menu, label: t('common.more') },
  ].filter((it) => instanciaTiene(it.modulo));

  return (
    <nav className="mobile-bottom-nav" role="navigation" aria-label="Mobile navigation">
      {items.map((item, i) => {
        if (item.action === 'sidebar') {
          return (
            <button
              key={i}
              className="mobile-bottom-nav-item"
              onClick={onOpenSidebar}
              type="button"
            >
              <item.icon />
              <span className="mobile-nav-label">{item.label}</span>
            </button>
          );
        }

        if (item.action === 'notifications') {
          return (
            <button
              key={i}
              className={`mobile-bottom-nav-item ${location.pathname === '/notifications' ? 'active' : ''}`}
              onClick={onOpenNotifications}
              type="button"
            >
              <item.icon />
              <span className="mobile-nav-label">{item.label}</span>
              {item.badge > 0 && (
                <span className="mobile-nav-badge">
                  {item.badge > 99 ? '99+' : item.badge}
                </span>
              )}
            </button>
          );
        }

        return (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => `mobile-bottom-nav-item ${isActive ? 'active' : ''}`}
          >
            <item.icon />
            <span className="mobile-nav-label">{item.label}</span>
            {item.badge > 0 && (
              <span className="mobile-nav-badge">
                {item.badge > 99 ? '99+' : item.badge}
              </span>
            )}
          </NavLink>
        );
      })}
    </nav>
  );
}
